import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EntityCardsComponent, SimpleEntityListPerspective } from '@homeleite/common-components';
import { ControllerDetailsDialogComponent } from './controller-details/controller-details-dialog/controller-details-dialog.component';
import { ControllersApiRepository } from '../../../../../../libs/domain/src/lib/controllers/controllers-api.repository';
import { Actives } from '@homeleite/arch';
import { Controller } from '@homeleite/domain';

@Component({
    selector: 'app-controllers',
    templateUrl: './controllers.component.html',
    styleUrls: ['./controllers.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ControllersComponent implements OnInit {
    @ViewChild('list') list: EntityCardsComponent;

    repository: ControllersApiRepository;

    perspective = new SimpleEntityListPerspective('default', [], [], Actives.ALL);

    search: string;
    entityTypes: any;

    constructor(
        private dialog: MatDialog,
        private controllerRepository: ControllersApiRepository
    ) {}

    ngOnInit(): void {
        this.repository = this.controllerRepository;
    }

    openControllerDialog(entity?: any): void {
        if (entity?.id) {
            // Card usa summary — carrega DTO completo só ao abrir o diálogo
            this.repository.find(entity.id).subscribe({
                next: (full) => this.openDialog(full ?? entity),
                error: () => this.openDialog(entity),
            });
            return;
        }
        this.openDialog(undefined);
    }

    private openDialog(entity?: Controller | any): void {
        const dialogRef = this.dialog.open(ControllerDetailsDialogComponent, {
            width: '100vw',
            height: '100vh',
            maxWidth: '100vw',
            disableClose: true,
            data: { entity }
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (!result) return;

            const controllerToSave = Controller.fromJson(result);
            const isNew = !entity;

            const saveObservable = isNew
                ? this.repository.insert(controllerToSave)
                : this.repository.update(controllerToSave);

            saveObservable.subscribe(() => {
                this.list.invalidate();
            });
        });
    }
}
